<template>
    <div class="flex h-screen bg-surface-50 dark:bg-surface-950">
        <Sidebar />
        <div class="flex flex-1 flex-col overflow-hidden">
            <Topbar />
            <main class="flex-1 overflow-auto p-4 md:p-6">
                <slot />
            </main>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import Sidebar from './components/Sidebar.vue'
    import Topbar from './components/Topbar.vue'
</script>
